// extracted by mini-css-extract-plugin
module.exports = {"page":"_5DOTRuR7","header":"_5D2oRnuI","main":"_5DnK9TOs","form":"_5D1q9wez","link":"_5D2PAIUq","sso":"_5D1TVEDU"};